import { render, staticRenderFns } from "./OrgHistoryTable.vue?vue&type=template&id=6501efdf&scoped=true"
import script from "./OrgHistoryTable.vue?vue&type=script&lang=js"
export * from "./OrgHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./OrgHistoryTable.vue?vue&type=style&index=0&id=6501efdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501efdf",
  null
  
)

export default component.exports